export default __webpack_public_path__ + "static/media/AnalyticsIQ-PeopleCore-Overview.c534614c.pdf";